export default {
  language: {
    label: "Sprache",
    search: "Sprache suchen",
    // Die in `plugins/i18n/locales.js` gelisteten Sprachen, für die es noch keine Übersetzung gibt.
    comingSoon: "Demnächst verfügbar",
    noResults: "Keine Sprache gefunden.",
  },
  profile: "Mein Profil",
  // Nur für Personen, die mehr als einem Arbeitsbereich angehören. Dass der Eintrag abmeldet, sagt
  // erst das Anmeldeformular (`auth.login.switch_workspace`).
  switchWorkspace: "Arbeitsbereich wechseln",
  theme: {
    label: "Erscheinungsbild",
    // "System" folgt der Einstellung des Betriebssystems und wechselt mit ihr mit.
    system: "System",
    light: "Hell",
    dark: "Dunkel",
  },
  help: {
    label: "Hilfe",
    tour: "Rundgang starten",
    releaseNotes: "Neuigkeiten",
    support: "Support kontaktieren",
    reportBug: "Fehler melden",
  },
}
